import { useState } from 'react';
import { toast } from 'react-toastify';
import fleetApi from '../../services/api.service';

const usePatchUnassignStep = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(null);
  const [data, setData] = useState(null);

  const unassignStep = async (tourId, stepId) => {
    resetStates();
    try {
      setIsLoading(true);
      const response = await fleetApi.patch(
        `/tours-planning/tours/${tourId}/steps/${stepId}/unassign`
      );

      if (response.status === 200) {
        setIsSuccess(true);
        setData(response.data);
        return response.data;
      } else {
        throw new Error(response.data?.message || 'Une erreur est survenue.');
      }
    } catch (error) {
      setIsSuccess(false);
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          'Erreur lors de la désaffectation'
      );
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  const resetStates = () => {
    setIsSuccess(false);
    setIsLoading(false);
    setData(null);
  };

  return {
    isLoading,
    isSuccess,
    data,
    unassignStep,
  };
};

export default usePatchUnassignStep;

